import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CaseStudy = ({
  title,
  company,
  image,
  link,
  locked,
  className,
  story
}) => {
  let _redirLink;

  if (locked) {
    _redirLink = `/password-gate?redirect=${link}`;
  } else {
    _redirLink = link;
  }

  return (
    <NavLink className={`case-study ${className}`} to={_redirLink}>
      <span className="case-study__arrow" aria-hidden>
        <FontAwesomeIcon icon="arrow-right" />
      </span>
      <div className="case-study__image">
        <img src={image} alt={`${title} Screenshot`} />
      </div>

      <div className="case-study__content">
        <header className="case-study__header">
          <h3 className="case-study__company">{company}</h3>
          <h2 className="case-study__title">{title}</h2>
        </header>
        <div className="case-study__body">{story}</div>
        {locked && (
          <div className="case-study__lock-note">
            <FontAwesomeIcon icon="lock" />
            <span>Locked</span>
          </div>
        )}
      </div>
    </NavLink>
  );
};

CaseStudy.propTypes = {
  title: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  locked: PropTypes.bool,
  className: PropTypes.string.isRequired,
};

export default CaseStudy;
